<template lang="">
  <div class="contents LogRecord__log_contents contents--pt">
    <section class="_min-h _pt-md">
      <div class="inner">
        <div class="LogRecord__area">
          <div class="LogRecord__box LogRecord__record">
            <div class="LogRecord__record_top">
              <div v-if="logDetail !== null" class="LogRecord__record_date ft_en">
                <span>{{ showSelectedDate(logDetail['created_at']) }}</span><span>&#040;{{ showSlectedDay(logDetail['created_at']) }}&#041;</span>
              </div>
              <div class="LogRecord__edit_btn" data-modal-open="log-1" @click="isOpenUpdateStep = true">
                編集
              </div>
              <a class="LogRecord__back_btn_arrow LogRecord__close" href="/log" />
            </div>
            <div class="LogRecord__record_area">
              <div v-if="logDetail !== null" class="LogRecord__record_inner">
                <div class="LogRecord__record_bar_area">
                  <div :class="`LogRecord__record_bar_box LogRecord__record_bar_box--${handleSlider(logDetail['heart_beat_rate'])}`">
                    <div class="LogRecord__record_bar_head _ft-cl04">
                      心の状態
                    </div>
                    <div class="LogRecord__record_bar">
                      <div class="LogRecord__record_bar_inner" />
                    </div>
                  </div>
                  <div :class="`LogRecord__record_bar_box LogRecord__record_bar_box--${handleSlider(logDetail['health_state'])}`">
                    <div class="LogRecord__record_bar_head _ft-cl05">
                      体の状態
                    </div>
                    <div class="LogRecord__record_bar LogRecord__record_bar--orange">
                      <div class="LogRecord__record_bar_inner" />
                    </div>
                  </div>
                </div>
                <div class="LogRecord__record_time">
                  <div class="LogRecord__record_time_box">
                    <div class="LogRecord__record_time_box_inner">
                      <div class="LogRecord__record_time_head">
                        <span class="LogRecord__record_time_head_tx">MELONでの瞑想</span>
                      </div>
                      <div class="LogRecord__record_time_tx">
                        <span class="LogRecord__record_time_tx_num ft_en">{{ logDetail['meditation_melontv'] }}</span><span>分</span>
                      </div>
                    </div>
                    <div class="LogRecord__record_notes">
                      ※クラス受講・MELON TVの視聴時間
                    </div>
                  </div>
                  <div class="LogRecord__record_time_box">
                    <div class="LogRecord__record_time_box_inner">
                      <div class="LogRecord__record_time_head">
                        <span class="LogRecord__record_time_head_tx">個人の瞑想</span>
                      </div>
                      <div class="LogRecord__record_time_tx">
                        <span class="LogRecord__record_time_tx_num ft_en">{{ logDetail['meditation_time'] }}</span><span>分</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="LogRecord__record_memo">
                  <div class="LogRecord__record_memo_head">
                    ジャーナリング
                  </div>
                  <div class="LogRecord__record_memo_area">
                    <p>{{ logDetail['diary'] }}</p>
                  </div>
                </div>
              </div>
              <a class="LogRecord__back_btn _hover-cl LogRecord__close" href="/log">戻る</a>
              <div class="LogRecord__record_con LogRecord__record_error _dsp-none">
                未来の日付のログはとれません
              </div>
              <div class="Btn Btn--line LogRecord__record_con LogRecord__record_btn _dsp-none" data-modal-open="log-1">
                ログをとる
              </div>
            </div>
            <log-update-modal
              :is-open="isOpenUpdateStep"
              :is-detail="logDetail"
              :list-zooms="listZoom"
              :list-melons="listMelonLog"
              :full-time="full_time"
              @close="handleClose()"
            />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import LogService from '@/services/logService'
import moment from 'moment'
import LogUpdateModal from '@/views/pages/log/components/LogUpdateModal'
import melonLogService from '@/services/melonLogService'
import zoomLogService from '@/services/zoomLogService'

export default {
  name: 'LogUpdateSP',
  components: { LogUpdateModal },
  data() {
    return {
      logDetail: null,
      isOpenUpdateStep: false,
      listZoom: [],
      listMelonLog: [],
      full_time: 0
    }
  },
  mounted() {
    this.getDetailLog()
  },
  methods: {
    async getDetailLog() {
      const id = this.$route.params.log_id
      const respone = await LogService.show(id)
      this.logDetail = respone.data
      const day = moment(this.logDetail.created_at).format('YYYY-MM-DD')
      zoomLogService.getTime(day).then(result => {
        this.listZoom = result.data
        this.full_time = result.time
      })
      melonLogService.getTime(day).then(result => {
        this.listMelonLog = result.data
        this.full_time += result.time
      })
    },
    handleSlider(slider) {
      if (slider < 10) {
        return '0' + slider
      }
      return slider
    },
    showSelectedDate(date) {
      return moment(date).format('YYYY.M.DD')
    },
    showSlectedDay(date) {
      return moment(date).format('ddd')
    },
    handleClose() {
      this.isOpenUpdateStep = false
      this.getDetailLog()
    }
  }
}
</script>
